<template>
  <div class="login">
    <app-header head-title="登录"></app-header>
    <div class="loginPart">
      <div class="banner">
        <div class="center">
          <div class="loginDiv" :class="{bigger:mobileLoginTab}">
            <div class="login-tab">
              <span
                class="accountLogin"
                :class="{active:!mobileLoginTab}"
                @click="mobileLoginTab=false"
              >账号密码登录</span>
              <span
                class="phoneLogin"
                :class="{active:mobileLoginTab}"
                @click="mobileLoginTab=true"
              >手机验证码登录</span>
            </div>
            <!-- 账号密码登录 -->
            <el-form
              ref="loginForm1"
              :model="loginForm1"
              :rules="loginRules"
              class="login-form"
              autocomplete="on"
              v-show="!mobileLoginTab"
            >
              <div class="error-code" v-if="captchaErrorForm2">{{ captchaErrorForm2 }}</div>
              <el-form-item prop="account">
                <el-input
                  ref="account"
                  v-model.trim="loginForm1.account"
                  placeholder="邮箱 / 手机"
                  name="account"
                  autocomplete="on"
                />
              </el-form-item>
              <el-form-item prop="password" style="margin-bottom:0" :error="accountPwdErrorMsg">
                <el-input
                  :key="passwordType"
                  ref="password"
                  v-model.trim="loginForm1.password"
                  :type="passwordType"
                  placeholder="密码"
                  name="password"
                  autocomplete="on"
                  @keyup.enter.native="handleLogin"
                  @focus="accountPwdErrorMsg = '';captchaErrorForm2=''"
                  maxlength="16"
                />
              </el-form-item>
              <!-- <div class="login-form-check-code-div">
                <el-form-item prop="captcha" class="check-code" :error="captchaErrorMsg" ref="captcha">
                  <el-input
                    v-model.trim="loginForm1.captcha"
                    type="text"
                    placeholder="图形码"
                    name="captcha"
                    maxlength="6"
                    @focus="captchaErrorMsg=''"
                  />
                </el-form-item>
                <img
                  ref="imgCodeLogin"
                  :src="!mobileLoginTab && varHost + 'uc/auth/login/captcha'"
                  @click="imgCodeRefreshByLogin()"
                  class="code-img"
                  alt="验证码"
                />
              </div> -->
            </el-form>
            <!-- 手机号登录 -->
            <el-form
              ref="loginForm2"
              :model="loginForm2"
              :rules="loginRules"
              class="login-form"
              autocomplete="on"
              v-show="mobileLoginTab"
            >
            <div class="error-code" v-if="captchaError">{{ captchaError }}</div>
              <el-form-item prop="phoneNumber" :error="phoneErrorMsg">
                <el-input
                  ref="phoneNumber"
                  v-model.number="loginForm2.phoneNumber"
                  placeholder="请输入手机号"
                  name="phoneNumber"
                  autocomplete="on"
                  @focus="phoneErrorMsg='';captchaError=''"
                  maxlength="11"
                />
              </el-form-item>
              <!--<div class="check-code-div">
                <el-form-item prop="code" class="check-code" :error="codeErrorMsg" ref="code">
                  <el-input
                    v-model.trim="loginForm2.code"
                    type="text"
                    placeholder="图形码"
                    name="code"
                    maxlength="6"
                    @focus="codeErrorMsg=''"
                  />
                </el-form-item>
                <img
                  ref="imgCode"
                  :src="mobileLoginTab && varHost + 'uc/auth/mobile-login/captcha'"
                  @click="imgCodeRefresh()"
                  class="code-img"
                  alt="验证码"
                />
              </div>-->
              <div class="check-phonecode-div">
                <el-form-item
                  class="phone-code"
                  prop="phoneCode"
                  style="margin-bottom:0"
                  :error="phoneLoginCodeErrorMsg"
                >
                  <el-input
                    ref="phoneCode"
                    v-model.trim="loginForm2.phoneCode"
                    placeholder="验证码"
                    name="phoneCode"
                    @keyup.enter.native="handleLogin"
                    maxlength="6"
                    @focus="phoneLoginCodeErrorMsg='';captchaError=''"
                  />
                  <el-button
                    :class="{'is-timing':able}"
                    type="primary"
                    class="codeBtn"
                    :disabled="able"
                    @click="checkPhonePrev"
                  >
                    <span v-show="show">获取验证码</span>
                    <span v-show="!show">{{count}} s</span>
                  </el-button>
                </el-form-item>
              </div>
            </el-form>
            <div class="commonLogin">
              <div class="autoLogin">
                <span class="autoLogin-btn">
                  <i class="icon" @click="autoLogin" ref="autologin"></i>下次自动登录
                </span>
                <span class="getBackPwd" @click="toGetBackPwd">找回密码</span>
              </div>
              <el-button
                :loading="loading"
                type="primary"
                class="loginBtn"
                @click.native.prevent="handleLogin"
              >登 录</el-button>
              <div class="toRegister">
                <span class="btn-toRegister" @click="toRegist">注册</span>
              </div>
              <div class="socialLoginIcon">
                <span class="wechat" @click="socialJump('wechat')"></span>
                <span class="weibo" @click="socialJump('weibo')"></span>
                <span class="qq" @click="socialJump('qq')"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
    <app-bind-phone :needBind="needBind" :needBindMobile="needBindMobile" @emitFn="emitFn"></app-bind-phone>
  </div>
</template>

<script>
import user from "@/api/user";
import header from "@/components/common/header";
import footer from "@/components/common/footer";
import tipsBindPhone from "@/components/common/tipsBindPhone";

export default {
  name: "Login",
  components: {
    "app-header": header,
    "app-footer": footer,
    "app-bind-phone": tipsBindPhone
  },
  data() {
    const validPhoneNumber = (rule, value, callback) => {
      if (("" + value).length !== 11) {
        callback(new Error("手机号格式不正确"));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号格式不正确"));
      } else {
        callback();
      }
    };
    const validateAccount = (rule, value, callback) => {
      if (
        /^1[3456789]\d{9}$/.test(value) ||
        /^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/.test(value)
      ) {
        callback();
      } else {
        callback(new Error("请输入手机号或邮箱号"));
      }
    };
    const validateCaptcha = (rule, value, callback) => {
      if (value.length != 6) {
        callback(new Error("请输入六位图形验证码"));
      } else {
        callback();
      }
    };
    const validateCode = (rule, value, callback) => {
      if (value.length != 6) {
        callback(new Error("请输入六位图形验证码"));
      } else {
        callback();
      }
    };
    const validatePhoneCode = (rule, value, callback) => {
      if (value.length != 6) {
        callback(new Error("请输入短信验证码"));
      } else {
        callback();
      }
    };
    var validatePassword = (rule, value, callback) => {
      var reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\S]{8,16}$/;
      if (value.length < 8 || value.length > 16) {
        callback(new Error("密码需为8～16位大小字母、数字组合"));
      } else if (!reg.test(value)) {
        callback(new Error("密码需为8～16位大小字母、数字组合"));
      } else {
        callback();
      }
    };
    return {
      captchaError: '',
      captchaErrorForm2: '',
      mobileLoginTab: false,
      captchaErrorMsg: "",
      codeErrorMsg: "",
      autoLoginBool: false,
      phoneErrorMsg: "",
      accountPwdErrorMsg: "",
      phoneLoginCodeErrorMsg: "",
      loginForm1: {
        account: "",
        password: "",
        // captcha: "",
        remember: 0,
        captcha_result: {
          ticket: "",
          randstr: ""
        }
      },
      loginForm2: {
        phoneNumber: "",
        code: "",
        phoneCode: "",
        ticket: "",
        randstr: ""
      },
      loginRules: {
        account: [
          { required: true, trigger: "blur", validator: validateAccount }
        ],
        phoneNumber: [
          { required: true, trigger: "blur", validator: validPhoneNumber },
          { type: "number", message: "手机号必须为数字值", trigger: "blur" }
        ],
        password: [{ required: true, trigger: "blur", message: "请输入密码" }],
        captcha: [{ required: true, trigger: "blur", validator: validateCaptcha }],
        code: [{ required: true, trigger: "blur", validator: validateCode }],
        phoneCode: [
          { required: true, trigger: "blur", validator: validatePhoneCode }
        ]      
      },
      loading: false,
      passwordType: "password",
      show: true,
      count: "",
      timer: null,
      able: false,
      needBind: false,
      needBindMobile: false,
      CaptchaAppId: '192261687',
    };
  },
  computed: {},
  watch: {},
  methods: {
    emitFn(bool) {
      this.needBind = bool;
      this.needBindMobile = bool;
    },
    checkLoginState() {
      user
        .getUserInfo()
        .then(result => {
          // console.log(result);
          //自动跳转
          this.$router.replace({ name: "index" });
        })
        .catch(err => {
          console.log(err);
          if (err.status == 403) {
            if (err.data.message === "社交账号登录，未绑定手机号") {
              this.needBind = true;
              // console.log(this.needBind)
            } else if (err.data.message === "未绑定手机号") {
              this.needBindMobile = true;
            }
          }
        });
    },
    socialJump(where) {
      // window.open(this.varHost + "uc/auth/socialite/" + where)
      window.location.href = this.varHost + "uc/auth/socialite/" + where;
    },
    // imgCodeRefreshByLogin() {
    //   this.$refs.imgCodeLogin.src =
    //     this.varHost + "uc/auth/login/captcha?" + Math.random();
    // },
    // imgCodeRefresh() {
    //   this.$refs.imgCode.src =
    //     this.varHost + "uc/auth/mobile-login/captcha?" + Math.random();
    // },
    checkPhonePrev(){
      let _this = this;
      this.$refs["loginForm2"].validateField("phoneNumber", error => {
        if (error) {
          return;
        } else {
          _this.getTcaptcha();
        }
      });      
    },  
    checkPhone() {
      // this.$refs["loginForm2"].validateField("phoneNumber", error => {
      //   if (error) {
      //     return false;
      //   } else {
      //     this.$refs["loginForm2"].validateField("code", error => {
      //       if (error) {
      //         return false;
      //       } else {

      //         this.getCode();
      //       }
      //     });
      //   }
      // });
      this.getCode();
    },
    getCode() {
      // 发送请求获取验证码
      this.able = true;
      user
        .getMsgNewLogin({
          mobile: this.loginForm2.phoneNumber,
          captcha_result: {
            randstr: this.loginForm2.randstr,
            ticket: this.loginForm2.ticket
          }
        })
        .then(response => {
          this.lockGetCode();
        })
        .catch(error => {
          this.able = false;
          this.errorMsgEmpty();
          // this.imgCodeRefresh();
          this.$nextTick(function() {
            if (typeof error == "string") {
              if(error === '验证码验证失败') {
                this.captchaError = error
              } else if (error == "手机号不存在") {
                this.phoneErrorMsg = error;
              } else {
                this.codeErrorMsg = error;
              }
              
            }
          });
          this.loginForm2.code = "";
          // this.$refs["code"].resetField();
        });
      // this.imgCodeRefresh();
    },
    lockGetCode() {
      // 倒计时
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            this.able = false;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    loginFormPrev() {
      this.loading = true;
      this.autoLoginBool
        ? (this.loginForm1.remember = 1)
        : (this.loginForm1.remember = 0);
      user
        .pwdLogin(this.loginForm1)
        .then(res => {
          // console.log(66, res);
          this.loading = false;
          if (res.data.redirect) {
            location.href = res.data.redirect;
          } else {
            this.$router.replace({ path: "/index" });
          }
        })
        .catch(error => {
          this.loading = false;
          // this.imgCodeRefreshByLogin()
          // console.log(error);
          this.errorMsgEmpty();
          let captchaErr = ['图形验证码不能为空', '图形验证码错误']
          if (error.data && error.data.message === "未绑定手机号") {
            this.needBindMobile = true;
          }
          this.$nextTick(function() {
            // typeof error == "string"
            //   ? captchaErr.includes(error) ?  (this.captchaErrorMsg = error) : (this.accountPwdErrorMsg = error)
            //   : true;
            // console.log(error,3333)
            this.$nextTick(function() {
            if (typeof error == "string") {
              if(error == '验证码验证失败') {
                this.captchaErrorForm2 = error
              } else if (captchaErr.includes(error)) {
                this.captchaErrorMsg = error
              } else {
                this.accountPwdErrorMsg = error
              }
              
            }
          });
          });
        });
    },
    handleLogin() {
      if (!this.mobileLoginTab) {
        this.$refs.loginForm1.validate(valid => {
          if (valid) {
            this.getTcaptcha();
            // this.loading = true;
            // this.autoLoginBool
            //   ? (this.loginForm1.remember = 1)
            //   : (this.loginForm1.remember = 0);
            // user
            //   .pwdLogin(this.loginForm1)
            //   .then(res => {
            //     // console.log(66, res);
            //     this.loading = false;
            //     if (res.data.redirect) {
            //       location.href = res.data.redirect;
            //     } else {
            //       this.$router.replace({ path: "/index" });
            //     }
            //   })
            //   .catch(error => {
            //     this.loading = false;
            //     // this.imgCodeRefreshByLogin()
            //     // console.log(error);
            //     this.errorMsgEmpty();
            //     let captchaErr = ['图形验证码不能为空', '图形验证码错误']
            //     if (error.data && error.data.message === "未绑定手机号") {
            //       this.needBindMobile = true;
            //     }
            //     this.$nextTick(function() {
            //       typeof error == "string"
            //         ? captchaErr.includes(error) ?  (this.captchaErrorMsg = error) : (this.accountPwdErrorMsg = error)
            //         : true;
            //     });
            //   });
          } else {
            // console.log("error submit!!");
            return false;
          }
        });
      } else {
        this.$refs.loginForm2.validate(valid => {
          if (valid) {
            this.loading = true;
            user
              .msgLogin({
                mobile: this.loginForm2.phoneNumber,
                mobile_verify_code: this.loginForm2.phoneCode
              })
              .then(res => {
                this.loading = false;
                if (res.data.redirect) {
                  location.href = res.data.redirect;
                } else {
                  this.$router.replace({ path: "/index" });
                }
              })
              .catch(error => {
                this.loading = false;
                this.errorMsgEmpty();
                this.$nextTick(function() {
                  typeof error == "string"
                    ? (this.phoneLoginCodeErrorMsg = error)
                    : true;
                });
              });
          } else {
            // console.log("error submit!!");
            return false;
          }
        });
      }
    },
    autoLogin() {
      if (this.autoLoginBool) {
        this.$refs.autologin.style.backgroundPosition = "-49px -19px";
        this.autoLoginBool = false;
      } else {
        this.$refs.autologin.style.backgroundPosition = "-19px -19px";
        this.autoLoginBool = true;
      }
    },
    errorMsgEmpty() {
      this.captchaError = ''
      this.captchaErrorForm2 = ''
      this.captchaErrorMsg = "";
      this.codeErrorMsg = "";
      this.phoneErrorMsg = "";
      this.accountPwdErrorMsg = "";
      this.phoneLoginCodeErrorMsg = "";
    },
    toRegist() {
      this.$router.push({ path: "/register" });
    },
    toGetBackPwd() {
      this.$router.push({ path: "/resetPassword" });
    },
    getTcaptcha() {
      let _this = this;
      try {
        // 生成一个验证码对象
        let captcha = new TencentCaptcha(this.CaptchaAppId, _this.callback, {});
        // 调用方法，显示验证码
        captcha.show();
      } catch (error) {
        // 加载异常，调用验证码js加载错误处理函数
        this.loadErrorCallback();
      }
    },
    callback(res) {
      // console.log('callback:', res);
      // res（用户主动关闭验证码）= {ret: 2, ticket: null}
      // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
      // res（请求验证码发生错误，验证码自动返回terror_前缀的容灾票据） = {ret: 0, ticket: "String", randstr: "String",  errorCode: Number, errorMessage: "String"}
      if (res.ret === 0) {
        // 验证成功
        if(!this.mobileLoginTab){
          this.loginForm1.captcha_result.ticket = res.ticket;
          this.loginForm1.captcha_result.randstr = res.randstr;
          this.loginFormPrev();
        }else {
          this.loginForm2.ticket = res.ticket;
          this.loginForm2.randstr = res.randstr;
          this.checkPhone();
        }
      }else if(res.ret === 2){
        this.loginForm1.captcha_result.ticket = '';
        this.loginForm1.captcha_result.randstr = '';
        this.loginForm2.ticket = '';
        this.loginForm2.randstr = '';
      }
    },
    loadErrorCallback() {
        let appid = this.CaptchaAppId;
        // 生成容灾票据或自行做其它处理
        let ticket = 'terror_1001_' + appid + '_' + Math.floor(new Date().getTime() / 1000);
        this.callback({
          ret: -1,
          randstr: '@' + Math.random().toString(36).substr(2),
          ticket: ticket,
          errorCode: 1001,
          errorMessage: 'jsload_error'
        });
    }
  },
  created() {
    this.checkLoginState();
  }
};
</script>

<style lang="scss">
// $bg: #283443;
// $light_gray: #fff;
// $cursor: #fff;

/* reset element-ui css */
.login {
  .el-input {
    display: inline-block;
    height: 42px;
    width: 318px;
    input {
      border-radius: 6px;
      padding: 12px 5px 12px 15px;
      // color: $light_gray;
      height: 42px;
      line-height: 40px;
      // caret-color: $cursor;
    }
  }

  .el-form-item {
    margin-bottom: 18px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 6px;
    color: #454545;
  }
  .login-form-check-code-div {
    width: 210px;
    position: relative;
    margin-top: 18px;
    margin-bottom: 0;
    .check-code {
      width: 210px;
      margin-bottom: 0;
      .el-input {
        width: 208px;
      }
    }
    .code-img {
      width: 100px;
      height: 36px;
      position: absolute;
      right: -110px;
      top: 4px;
    }
  }
  .check-code-div {
    width: 210px;
    position: relative;
    .check-code {
      width: 210px;
      .el-input {
        width: 208px;
      }
    }
    .code-img {
      width: 100px;
      height: 36px;
      position: absolute;
      right: -110px;
      top: 4px;
    }
  }
  .check-phonecode-div {
    width: 210px;
    position: relative;
    .el-input {
      width: 208px;
    }
    .el-button.codeBtn {
      width: 100px;
      height: 42px;
      position: absolute;
      right: -110px;
      top: 0px;
      padding: 0;
    }
  }
}
</style>

<style lang="scss" scoped>
// $bg: #2d3a4b;
// $dark_gray: #889aa4;
// $light_gray: #eee;

.login {
  width: 100%;
  overflow: hidden;
  .loginPart {
    padding-top: 40px;
    margin-bottom: 30px;
    height: 577px;
    background: url(../../assets/images/LoginBG.jpg) no-repeat center;
    background-size: cover;
    .center {
      height: 577px;
      text-align: center;
      background: url(../../assets/images/WWW.png) no-repeat 6% center;
      position: relative;
      width: 1000px;
      margin: 0 auto;
    }
    .loginDiv {
      box-shadow: 0 1px 50px 0 #dfd3c2;
      width: 380px;
      height: 490px;
      background-color: #fff;
      border-radius: 10px;
      position: absolute;
      right: 0;
      top: 44px;
      .login-tab {
        height: 60px;
        border-bottom: 1px solid #f4e4cd;
        span {
          display: inline-block;
          color: #999;
          height: 50px;
          width: 100px;
          font-size: 14px;
          margin: 0 10px;
          margin-top: 8px;
          line-height: 50px;
          position: relative;
          cursor: pointer;
        }
        span.active {
          color: #595959;
          &::after {
            content: "";
            display: block;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            width: 70px;
            height: 3px;
            background-color: #f44533;
          }
        }
      }
    }
    .loginDiv.bigger {
      height: 490px;
      top: 44px;
    }
  }
  .login-form {
    position: relative;
    max-width: 100%;
    padding: 20px 30px;
    margin: 0 auto;
    overflow: hidden;
  }
  .commonLogin {
    margin-top: 20px;
    padding: 0 30px;
  }
  .autoLogin {
    font-size: 14px;
    height: 30px;
    cursor: pointer;
    .autoLogin-btn {
      float: left;
      color: #595959;
      .icon {
        width: 16px;
        height: 16px;
        float: left;
        margin-right: 6px;
        background: url("../../assets/images/icons.png") no-repeat -49px -19px;
      }
    }
    .getBackPwd {
      float: right;
      color: #4981f2;
    }
  }
  .toRegister {
    text-align: right;
    .btn-toRegister {
      color: #4981f2;
      cursor: pointer;
      font-size: 12px;
    }
  }
  .loginBtn {
    font-size: 18px;
    width: 100%;
    margin-bottom: 8px;
    color: #ffffff;
    font-family: Microsoft YaHei;
    word-spacing: 10px;
  }
  .socialLoginIcon {
    margin-top: 4px;
    text-align: center;
    height: 50px;
    font-size: 0;
    span {
      margin: 0 14px;
      width: 50px;
      height: 50px;
      display: inline-block;
      cursor: pointer;
    }
    .wechat {
      background: url("../../assets/images/icons.png") no-repeat -20px -48px;
    }
    .weibo {
      background: url("../../assets/images/icons.png") no-repeat -78px -48px;
    }
    .qq {
      background: url("../../assets/images/icons.png") no-repeat -136px -108px;
    }
    .people {
      width: 46px;
      height: 46px;
      background: url("../../assets/images/people.png") no-repeat center/cover;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    // color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
  .error-code {
    font-size: 12px;
    position: absolute;
    top: 128px;
    z-index: 100;
    color: #f00;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/index.vue